<script setup lang="ts">
import { computed, ref } from "vue";

import FileRedactionMessage from "@/components/FileRedactionMessage.vue";
import VoicePlayerFile from "@/components/CasePanels/VoicePlayer/VoicePlayerFile.vue";

import { isItemBurning, isShowingFile } from "@/services/UtilitiesService";

import { useMetadataStore } from "@/stores/metadata-store";
import { useCaseFileStore } from "@/stores/case-file-store";

import { useCaseRouteParams } from "@/hooks/use-case-route-params";

import type { DockviewPanelComponentProps, DockviewPanelComponentEmits } from "@/hooks/use-case-panel";

withDefaults(defineProps<DockviewPanelComponentProps<false>>(), {  })
defineEmits<DockviewPanelComponentEmits>();

const routeParams = useCaseRouteParams();

const fallbackSize = ref({
  width: window.innerWidth,
  height: window.innerHeight - 60,
});

const cachedFiles = computed(() => {
  const filesByRef = useMetadataStore().filesByRef;
  return useCaseFileStore().cachedFiles.flatMap((c) => filesByRef[c.fileReference] ?? []);
});
</script>
<template>
  <div v-if="cachedFiles.length < 1 && routeParams.casefile == null" class="tw-grid tw-size-full tw-place-items-center">
    <div class="tw-max-w-sm tw-text-pretty">No file selected</div>
  </div>
  <template v-for="file in cachedFiles" v-else :key="file.fileReference">
    <template v-for="(isShowing, idx) in [isShowingFile(file)]" :key="idx">
      <FileRedactionMessage
        v-if="isShowing && isItemBurning(file)"
        class="tw-absolute tw-left-0 tw-top-0 tw-flex tw-size-full tw-items-center tw-justify-center tw-p-4"
        :file="file"
        :route-params="routeParams"
      />
      <VoicePlayerFile
        v-else
        v-show="isShowing"
        :file="file"
        :is-popout="false"
        :route-params="routeParams"
        :scale="dockview?.size ?? fallbackSize"
        :is-visible="(dockview?.isVisible ?? true) && isShowing"
      />
    </template>
  </template>
</template>
